import graphql__d9f1813304dca9650bb2 from "./__generated__/useFilterConditionnallyHiddenAnswers_answers.graphql.js";import { useEffect, useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch } from "react-redux";

import { useForm } from "../Form/withFormStore";
import { shouldAnswerBeDisplayed } from "./useAnswerShouldBeConditionnallyHidden";

import { removeField } from "../../reducers/form";

export const useFilterConditionnallyHiddenAnswers = props => {
  const answers = useFragment(
    useFilterConditionnallyHiddenAnswers_answers, 
    props.answers
  );

  const { formKey, formState } = useForm();

  // Keep the original answers to be able to filter them out later and return the original
  // answers, and not the answer data that we use to filter them.
  const propsAnswersById = useMemo(
    () => props.answers.reduce((acc, answer) => ({ ...acc, [answer.id]: answer }), {}),
    [props.answers]
  );

  // Enhance the answers with a `shouldBeDisplayed` field that will be used to return the 
  // filtered original answers, and also to remove the hidden fields from the form state,
  // to avoid hidden answers to be stored in the form answer's backend store.
  const answersWithDisplableState = useMemo(
    () => 
      answers.map(answer => {
        const shouldBeDisplayed = shouldAnswerBeDisplayed(answer, formState);
        
        return { ...answer, shouldBeDisplayed };
      }, {}),
    [answers, formState]
  );

  const dispatch = useDispatch();

  // This allows removing the fields from the schema when they're not displayed, avoiding
  // validation errors and sending hidden data.
  useEffect(() => {
    answersWithDisplableState.forEach(answer => {
      const { shouldBeDisplayed, formField: { fieldName } } = answer;

      // Don't try to remove fields that should be displayed, neither those that should
      // be hidden but are not stored in the form state, like the presentation fields.
      if (shouldBeDisplayed || !formState.fields[fieldName]) return;

      dispatch(removeField(formKey, fieldName));
    });
  }, [answersWithDisplableState, dispatch, formKey, formState.fields]);
  
  const filteredAnswers = useMemo(
    () => answers.reduce(
      (acc, answer) => {
        const answerWithDisplableState = 
          answersWithDisplableState.find(({ id }) => id === answer.id);
        
        return answerWithDisplableState.shouldBeDisplayed
          ? [...acc, propsAnswersById[answer.id]]
          : acc;
      }, []),
    [answers, answersWithDisplableState, propsAnswersById]
  );

  return filteredAnswers;
};

const useFilterConditionnallyHiddenAnswers_answers = graphql__d9f1813304dca9650bb2;
